import { config } from '@bounty/creators-design-system'

export default config
